var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"master-layout"}},[_c('TheHeader'),_c('main',{attrs:{"id":"master-layout__content"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }